export default __webpack_public_path__ + "static/media/T500_CoC.b6758712.pdf";